import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (confirm("There is already a user with this email. Do you want to make them a sub user on this account?")) {
      const forceUpdateInput = document.getElementById("user_force_update_parent_id");
      if (forceUpdateInput) forceUpdateInput.value = "true";
      const subUsersForm = document.getElementById("sub-users-form");
      if (subUsersForm) subUsersForm.submit();
    }
  }
}
